import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-document-pdf-safari-modal',
    templateUrl: './document-pdf-safari-modal.component.html',
    styleUrls: ['./document-pdf-safari-modal.component.scss'],
    standalone: false
})
export class DocumentPdfSafariModalComponent implements OnInit {

  private _pdfLink: SafeUrl;
  public isVisible = false;

  @Input() set pdfLink(link: string) {
    if(link) {
      this.isVisible = true;
      this._pdfLink = this.domSanitizer.bypassSecurityTrustUrl(link);
      return;
    }
    this._pdfLink = link;
  }
  constructor(private domSanitizer: DomSanitizer) { }

  get pdfLink() {
    // @ts-ignore
    return this._pdfLink;
  }

  ngOnInit() {
  }

  public openLink(): void {
    this.handleCancel();
  }

  public handleCancel(): void {
    this.isVisible = false;
    this.pdfLink = '';
  }
}
